const setCustomConsole = () => {
  const envID = import.meta.env.VITE_APP_ENV;
  const altConsole = { ...console };
  console.log = (...data) => envID !== "production" && altConsole.log(...data);
};

export default setCustomConsole;
